import { render, staticRenderFns } from "./TraxTrainingRegistrationForceDeleteWarning.vue?vue&type=template&id=42aa2206"
import script from "./TraxTrainingRegistrationForceDeleteWarning.vue?vue&type=script&lang=js"
export * from "./TraxTrainingRegistrationForceDeleteWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports